import React from "react";
import { colorBlockShipment } from "../../helpers/Utils";
import ShipmentEmailPreview from "../common/GlobalModals/Orders/editModal/Shippment/ShipmentEmailPreview";
import { formatDateTime } from "../../utils/date";

function CourierLinksComponent({ shipments }) {
  return (
    <>
      {shipments &&
        shipments.map((shipment, shipmentIndex) =>
          Array.isArray(shipment?.courier_trackings) &&
            shipment?.courier_trackings?.length > 0 ? (
            <React.Fragment key={`${shipment.id}-${shipmentIndex}`}>
              <div className="text-black text-xs">
                {formatDateTime(shipment.created_at)}
              </div>
              {shipment?.courier_trackings.map(
                (courier_tracking, trackingIndex) => (
                  <div
                    className="d-flex align-items-center mb-2"
                    key={`${courier_tracking?.number}-${trackingIndex}-${shipmentIndex}-${shipment.id}`}
                  >
                    <ShipmentEmailPreview
                      shipment_emails={shipment?.shipment_emails || []}
                      tracking_number={courier_tracking.number}
                    />
                    <a
                      className={colorBlockShipment(shipment)}
                      key={`${courier_tracking.url}-${trackingIndex}`}
                      href={courier_tracking.url}
                      target="_blank"
                    >
                      {courier_tracking?.number}
                    </a>
                  </div>
                )
              )}
            </React.Fragment>
          ) : shipment?.external_order_number ? (
            <div
              className="text-danger"
              key={`${shipment?.external_order_number}-${shipmentIndex}`}
            >
              EN: {shipment?.external_order_number}
            </div>
          ) : null
        )}
    </>
  );
}

export default CourierLinksComponent;
